module.exports = __webpack_public_path__ + "static/media/left_layout_image_Car.2c36c438.svg";